/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import clsx from 'clsx';
import parse from 'html-react-parser';
import webinaireImg from '../img/webinaire_2.jpg';
import webinaireServices from '../../redux/services/webinaireServices';
import { Loading } from '../../helpers/utils';
import { useWebinaireListStyles } from './webinaireStyles';

const bgStyle = {
  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.94)), url(${webinaireImg})`,
};

const OldWebinaire = ({ setErrorSnackBar }) => {
  const classes = useWebinaireListStyles();
  const [webinaires, setWebinaires] = useState([]);
  const [loading, setLoading] = useState(true);

  const getWebinairesData = async () => {
    const webinaireRes = await webinaireServices.getWebinaires();
    if (webinaireRes && webinaireRes.length > 0) {
      const newWebinaires = webinaireRes.filter((webinaire) => new Date(webinaire.start) < new Date());
      setWebinaires(newWebinaires);
      setLoading(false);
    } else {
      setErrorSnackBar({ code: 400, message: 'Failed to fetch webinaires', severity: 'error' });
      setLoading(false);
    }
  };

  useEffect(() => {
    getWebinairesData();
  }, []);

  const handleDownload = async (filename) => {
    const downloadedFile = await webinaireServices.getRecording(filename);
    window.location.href = downloadedFile.url;
  };

  return (
    <div
      className={clsx(classes.page, classes.pageWithBg)}
      style={bgStyle}
    >
      {!loading ? (
        <>
          {webinaires.length > 0 ? (
            webinaires.map((webinaire) => (
              <Paper
                key={webinaire._id}
                className={classes.card}
                elevation={2}
              >
                <div className={classes.cardHeaderRow}>
                  <Typography component="h2" variant="h6" className={classes.title} style={{ marginTop: 0 }}>
                    {webinaire.topic}
                  </Typography>
                </div>
                <Typography component="div" variant="body2" align="justify">{parse(webinaire.blurb)}</Typography>
                <div className={classes.actions}>
                  <Button
                    onClick={() => handleDownload(webinaire.recording)}
                    variant="contained"
                    color="primary"
                    disableElevation
                    size="small"
                    disabled={!webinaire.recording}
                    aria-label={webinaire.recording ? `Télécharger le replay de ${webinaire.topic}` : `Replay de ${webinaire.topic} indisponible`}
                  >
                    {webinaire.recording ? 'Télécharger' : 'En attente'}
                  </Button>
                </div>
              </Paper>
            ))
          ) : (
            <div className={classes.emptyState}>
              <Typography component="h2" variant="h6" className={classes.emptyTitle}>
                Aucun replay disponible pour le moment.
              </Typography>
              <Typography variant="body2" className={classes.emptyHint}>
                Les enregistrements apparaîtront ici une fois publiés.
              </Typography>
            </div>
          )}
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default OldWebinaire;
